import { RefObject, useEffect, useState } from 'react';

import { AriseBridgeService } from '@/arise/bridge/AriseBridgeService';
import { AriseBridgeHost } from '@/arise/bridge/AriseBridgeHost';

// Global ref for accessing bridge outside React components
export const globalBridgeRef: { current: AriseBridgeHost | null } = { current: null };

export function useAriseBridge(iframeRef: RefObject<HTMLIFrameElement>, options: any = {}) {
    const [ariseBridge, setAriseBridge] = useState<AriseBridgeHost | null>(null);

    useEffect(() => {
        const allowedOrigins = options.allowedOrigins || ['*'];
        const abs = AriseBridgeService.initialise(iframeRef, allowedOrigins, options.arisewareProjectID);
        const bridge = abs.getBridge();
        setAriseBridge(bridge);
        globalBridgeRef.current = bridge;
        return () => {
            globalBridgeRef.current = null;
        };
    }, [iframeRef]);

    return ariseBridge;
}
